import { FC, useEffect, useState } from "react";
import { Column } from "../../../../../components/containers";
import { UserEditPopupProps } from "./types";
import { PopupBack, PopupClose } from "../../../../../popup";
import UserProfilePopup from "../user-profile-popup";
import { FileInput, TextInput } from "../../../../../components/inputs";
import type { AccessList as AccessListType } from "../../types";
import {
  useAlertStore,
  usePopupStore,
  useThemeStore,
} from "../../../../../stores";
import AccessList from "../access-list";
import { Button } from "../../../../../components/buttons";
import styles from "../styles";
import { UserApi } from "../../../../../api";

const UserEditPopup: FC<UserEditPopupProps> = (props) => {
  const theme = useThemeStore((s) => s.theme);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);

  const { access_list, fullname, role, username, readOnly = false } = props;

  const [_fullname, setFullname] = useState<string>("");
  const [_role, setRole] = useState<string>("");
  const [_access_list, setAccessList] = useState<AccessListType>([
    ...access_list,
  ]);
  const [_username, setUsername] = useState<string>("");
  const [_password, setPassword] = useState<string>("");
  const [_confirmPassword, setConfirmPassword] = useState<string>("");
  const [files, setFiles] = useState<FileList | null>(null);

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxWidth: 430,
        background: theme.background,
        height: "100%",
        maxHeight: 605,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pushAlert = useAlertStore((s) => s.pushAlert);

  const onUpdate = (): void => {
    setLoading(true);
    UserApi.updateUser(
      props._id,
      _fullname,
      _role,
      _username,
      _password,
      _confirmPassword,
      _access_list,
      files ? files[0] : null
    )
      .then(() => {
        setPopupBody(null);
        pushAlert("عملیات موفقیت آمیز");
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Column style={styles.userPopupBase}>
      <PopupClose />
      <PopupBack props={props} Component={UserProfilePopup} />
      <Column style={styles.userPopupContainer} gap={15}>
        <FileInput
          label="عکس پروفایل"
          value={files}
          setValue={setFiles}
          background={theme.overlay}
          inputProps={{ readOnly }}
        />
        <TextInput
          label="نام و نام خانوادگی"
          value={_fullname}
          setValue={setFullname}
          background={theme.overlay}
          inputProps={{ readOnly, placeholder: fullname }}
        />
        <TextInput
          label="سمت"
          value={_role}
          setValue={setRole}
          background={theme.overlay}
          inputProps={{ readOnly, placeholder: role }}
        />
        <AccessList
          style={{ width: "100%" }}
          accessList={_access_list}
          updateAccessList={setAccessList}
          readOnly={readOnly}
        />
        <TextInput
          label="نام کاربری"
          value={_username}
          setValue={setUsername}
          background={theme.overlay}
          inputProps={{ readOnly, placeholder: username }}
        />
        <TextInput
          label="رمز عبور"
          value={_password}
          setValue={setPassword}
          background={theme.overlay}
          inputProps={{ readOnly, type: "password" }}
        />
        <TextInput
          label="تایید رمز عبور"
          value={_confirmPassword}
          setValue={setConfirmPassword}
          background={theme.overlay}
          inputProps={{ readOnly, type: "password" }}
        />
        {!readOnly ? (
          <Button
            loading={loading}
            onClick={onUpdate}
            background={theme.primary}
            color={theme.textOnprimary}
          >
            ثبت
          </Button>
        ) : (
          <></>
        )}
      </Column>
    </Column>
  );
};

export default UserEditPopup;
